import http from "../http-common";

class WarrantyService {
    create(data) {
        return http.post("/api/v1/warranties", data);
    }
}

export default new WarrantyService();